export default function RailRunnerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#4fb3ff" />
      <path d="M22 26L2 64h60L42 26z" fill="#8f7b61" />
      <path d="M26 26L16 64M38 26l10 38" stroke="#e5e9f0" strokeWidth="3" />
      <rect x="35" y="10" width="20" height="30" rx="4" fill="#2f8bff" />
      <rect x="38" y="14" width="14" height="9" rx="2" fill="#10284a" />
      <rect x="35" y="29" width="20" height="3" fill="#ffd84d" />
      <ellipse cx="14.5" cy="31" rx="2.2" ry="4.5" fill="#e0602a" transform="rotate(25 14.5 31)" />
      <circle cx="21" cy="30" r="5.5" fill="#ffcf9e" />
      <path d="M15.5 29a5.5 5.5 0 0 1 11 0z" fill="#e0602a" />
      <rect x="15.5" y="26.5" width="11" height="2" fill="#ff4fa3" />
      <rect x="15" y="35" width="12" height="13" rx="4" fill="#1fb5a3" />
      <path d="M17 48l-4 8M25 48l5 7" stroke="#2a3a66" strokeWidth="4" strokeLinecap="round" />
      <circle cx="10" cy="16" r="4" fill="#ffd23f" stroke="#c98a00" strokeWidth="1.5" />
      <circle cx="21" cy="12" r="4" fill="#ffd23f" stroke="#c98a00" strokeWidth="1.5" />
    </svg>
  );
}
